import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Header from "../common/Header";

const Container = styled.div`
  display: flex;
  font-family: "SpoqaHanSansNeoRegular";
  flex-direction: column;
  align-items: center;
  gap: 32px;
  background: ${(props) => `${props.theme.colors.white}`};
`;

const Wrapper = styled.div`
  width: 328px;
`;

const H = styled.h1`
  font-weight: 700;
  font-size: 24px;
  font-style: normal;
  line-height: 36px;
  color: ${(props) => `${props.theme.colors.black}`};
  margin-bottom: 8px;
`;

const P = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: normal;
  font-style: normal;
  color: #7d7878;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #7d7878;
`;

const Div = styled.div`
  width: 71px;
  height: 48px;
  border: 1px solid lightgray;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Finish = () => (
  <Container>
    <Header button={false} />
    <Wrapper>
      <H>📱 신청이 완료되었습니다!</H>
      <P>
        신청하신 내용을 보고 케어코디님들이 지원할 예정입니다.
        <br />
        케어코디님들이 신청할 때 마다 앱이나 문자로 알림을 보내드립니다.
        <br />
        케어코디님의 지원 알림을 기다려주세요!
      </P>
    </Wrapper>
    <StyledLink to="/">
      <Div>끝내기</Div>
    </StyledLink>
  </Container>
);

export default Finish;
